import React from 'react';
import './jh.css';

function Navjh() {
  return (
    <nav className="fixed-top navbar-expand-md navbar-light bg-light">
      <div className="container d-flex align-items-center">
        <div className="caminhao-container">
          <img
            src="/Images/Parceiros/sites/Jh/logo-jh.png"
            alt="Logo Caminhão"
            className="caminhao-img"
          />
          <h1 className="titulo-jh">TRANSPORTE DE MINÉRIOS</h1>
        </div>
      </div>
    </nav>
  );
}

export default Navjh;
